import axios from 'axios';
import url from './base-url';
const api = axios.create({
    baseURL: url
});
function Headers(auth){
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const getOrderSummary = (userId,auth) => api.get(`/dashboard/order/summary/${userId}`,Headers(auth));
export const getSalesByStore = (userId,auth) => api.get(`/dashboard/order/store-sales/${userId}`,Headers(auth));
export const getTotalOrderByWeekMonth = (userId,auth) => api.get(`/dashboard/order/total-order/${userId}`,Headers(auth));
export const getTopProduct = (userId,auth) => api.get(`/dashboard/order/top-product/${userId}`,Headers(auth));
export const getShipmentByCarrier = (userId,auth) => api.get(`/dashboard/order/get-shipment-carrier/${userId}`,Headers(auth));
export const getUpcomingEvent = (userId, date,auth) => api.get(`/dashboard/order/get-upcoming-event/${userId}/${date}`,Headers(auth));

const apis = {
    getOrderSummary,
    getSalesByStore,
    getTotalOrderByWeekMonth,
    getTopProduct,
    getShipmentByCarrier,
    getUpcomingEvent
}
export default apis;